import { progressUpdate as progressUpdateAnalytics } from '../../../../Modules/Analytics/trackActionInterface/Impact/ProgressUpdate'
import { analytics } from '../../../../Modules/Analytics'

export const dispatchAddUpdateClicked = ({
  goalId,
  platformPlan,
  userId,
}: {
  goalId: number
  platformPlan: string | null
  userId: number
}) => {
  analytics.trackActionCreator(progressUpdateAnalytics.Add_Update_Clicked)({
    goalId,
    platformPlan,
    userId,
  })
}

export const dispatchProgressUpdateAdded = ({
  progressUpdateId,
  goalId,
  platformPlan,
  userId,
  description,
}: {
  progressUpdateId: number | undefined
  goalId: number
  platformPlan: string | null
  userId: number
  description: string
}) => {
  analytics.trackActionCreator(progressUpdateAnalytics.Update_Added)({
    progressUpdateId,
    goalId,
    platformPlan,
    userId,
    description,
  })
}

export const dispatchProgressUpdateDismissed = ({
  goalId,
  platformPlan,
  userId,
  description,
}: {
  goalId: number
  platformPlan: string | null
  userId: number
  description: string
}) => {
  analytics.trackActionCreator(progressUpdateAnalytics.Update_Dismissed)({
    goalId,
    platformPlan,
    userId,
    description,
  })
}

export const dispatchProgressUpdateEdited = ({
  progressUpdateId,
  goalId,
  platformPlan,
  userId,
  description,
}: {
  progressUpdateId: number | undefined
  goalId: number
  platformPlan: string | null
  userId: number
  description: string
}) => {
  analytics.trackActionCreator(progressUpdateAnalytics.Update_Edited)({
    progressUpdateId,
    goalId,
    platformPlan,
    userId,
    description,
  })
}

export const dispatchProgressUpdateDeleted = ({
  progressUpdateId,
  goalId,
  goalTitle,
  platformPlan,
  userId,
  description,
}: {
  progressUpdateId: number
  goalId: number
  goalTitle: string
  platformPlan: string | null
  userId: number
  description: string
}) => {
  analytics.trackActionCreator(progressUpdateAnalytics.Update_Deleted)({
    progressUpdateId,
    goalId,
    goalTitle,
    platformPlan,
    userId,
    description,
  })
}
